import {Vue, Component, Prop} from 'vue-property-decorator';
import {GetClaimsNo} from 'supporter';
import {ClaimType, WithdrawValidationType} from '@/types/claim';
import {popupResize} from '@/utils/ncp';

@Component
export default class PopupBasic extends Vue {
  @Prop({required: true})
  private claimType!: ClaimType;

  @Prop({required: true})
  protected claimNoResponseData!: GetClaimsNo;

  protected claimStatusType: string = '';

  protected async checkAmountChangeAndGetConfirmMessage() {
    const request = {
      pathParams: {
        no: this.$route.query.claimNo.toString()
      }
    };
    const {
      data: {validationType, afterClaimNos}
    } = await this.$api.getClaimsNoCheckWithdraw(request);


    const afterClaimMessage = validationType === WithdrawValidationType.WITHDRAWABLE ? 'CLAIM_POPUP_ASK_WITHDRAW_MESSAGE' : 'CLAIM_POPUP_ASK_AMOUNT_CHANGED_WITHDRAW_MESSAGE';
    const afterClaimNosForMessage = validationType === WithdrawValidationType.WITHDRAWABLE ? null : afterClaimNos.toString()


    let confirmMessage = `${this.$t(afterClaimMessage)}`
    if(afterClaimNosForMessage !== null){
      confirmMessage += `\n${this.$t('CLAIM_POPUP_AFTER_CLAIM_NOS')}: ${afterClaimNos}`
    }

    return confirmMessage
  }

  protected created() {
    this.claimStatusType = this.claimNoResponseData.claimStatusType;
    document.body.classList.add('popup_large');
  }

  protected mounted() {
    this.$nextTick(() => {
      document.body.classList.add('popup_large');
      popupResize();
    });
  }

  protected onClickClose() {
    window.close();
  }

  protected reload() {
    if (window.opener.location.href.includes('order/detail')) {
      window.opener.location.reload();
    }

    if (this.$route.query && this.$route.query.callback) {
      $(window.opener.location).attr('href', `javascript:${this.$route.query.callback}('1');`);
    }
  }
}
